import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import Spinner from '../Spinner/Spinner';
import { setUserDetails, getUserDetails } from '../../Utility/UserUtility';
import { useNavigate } from 'react-router-dom';
import { format, addDays } from 'date-fns';
import { useLocation } from 'react-router-dom';


const OrderStatus = () =>{
    const location = useLocation();

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [OrderList, setOrderList] = useState<any[]>([]);
    const [OrderId, setOrderId] = useState<any>('');

   useEffect(function(){
       
       let userDetails : any = getUserDetails();
       if(userDetails?.User?.User_Id){
           GetOrderStatus();
       }
       else{
           navigate('/');
       }

      

   },[]);

const GetOrderStatus = () => {
       setIsLoading(true);

       const params = new URLSearchParams(location.search); 
       const Order_Id = params.get('oid')
       let userDetails : any = getUserDetails();
       setOrderId(Order_Id);
       apiGet(`api/Order/GetOrderStatus?User_Id=${userDetails?.User?.User_Id} &Order_Id=${Order_Id}`).then((res: any) => {
           
           setOrderList(res?.Data);
        setIsLoading(false);
   });
}

const onChangeCheckToCancel =(event : any,index : any) =>{
        
        let isChecked = (event?.target?.checked);
        OrderList[index].CheckToCancel = isChecked;
        setOrderList(OrderList);
}

const handlePreviewOrder = () =>{

}

const handleBackPreviewOrder = () =>{
        navigate('/Order');
}


    
    return(<>
        {(isLoading && <Spinner></Spinner>)} 
        <div className=" breadcrumb-padding-180"></div>

       <div className="cart-section section-padding">
           <div className="container">
               <div className="section-title-area">
                   <div className="section-title center">
                       <h3 className="wow fadeInUp" data-wow-delay=".3s"><br/>Order Details	</h3>
                       <span  data-wow-delay=".3s"><br/>Order Id : {OrderId}	</span>
                   </div>
               </div>

               <div className="main-cart-wrapper">
                   <div className="row g-5">
                       <div className="col-xl-12 Cancel">
                           <div className="table-responsive ">
                           
                               <table className="table">
                                   <thead>
                                       <tr>
                                           <th className="cart-border">Item Title</th>
                                           <th className="cart-border">ISBN</th>
                                           <th className="cart-border">Quantity</th>
                                           <th className="cart-border">Price</th>
                                           <th className="cart-border">Status</th>
                                           <th className="cart-border">Sub Total</th>
                                           {/* <th className="cart-border">Check To Cancel</th> */}
                                       </tr>
                                       <tr className="border-bottom"></tr>
                                   </thead>
                                   <tbody>
                                      {
                                           OrderList?.map( (item : any, index : any )=>(
                                            <tr>
                                           <td className="cart-border">
                                               <span className="cart-title">{item?.Item_Title}</span>
                                           </td>
                                            <td className="cart-border">
                                               <span className="cart-title">{item?.Seller_Sku}	</span>
                                           </td>
                                           <td className="cart-border">
                                               <span className="cart-title">{item?.Item_Quantity}	</span>
                                           </td>
                                           <td className="cart-border">
                                               <span className="cart-title">{item?.Item_Price}</span>
                                           </td>
                                            <td className="cart-border">
                                               <span className="cart-title">{item?.Order_ShipStatus}</span>
                                           </td>
                                           <td className="cart-border">
                                               <span className="cart-title">{( parseInt(item?.Item_Quantity) * parseFloat(item?.Item_Price))}</span>
                                           </td>
                                            {/* <td className="cart-border">
                                              <input className="form-check-input" type="checkbox" value="" onClick={(e)=>onChangeCheckToCancel(e,index)} ></input>
                                           </td> */}
                                       </tr>
                                           ))
                                      } 
                                   </tbody>
                               </table>
                               <span className="cart-title" style={{float:"left"}} ><a className="btn btn-secondary" onClick={() => handleBackPreviewOrder()} >Back</a></span>
                                {/* <span className="cart-title" style={{float:"right"}} ><a className="theme-btn " onClick={() => handlePreviewOrder()} >Preview Order</a></span> */}
                           </div>
                           
                       </div>
                       
                   </div>
               </div>


               {/* <div className="main-cart-wrapper">
                   <div className="row g-5">
                       <div className="col-xl-12 Cancel">
                           <div className="table-responsive ">
                           
                               <table className="table">
                                   <tbody>
                                        <tr>
                                           <td className="cart-border">
                                               <span className="cart-title"><b>Shipping Address</b></span><br/>
                                               <span className="cart-title">Ravinder Kumar1 </span><br/>
                                               <span className="cart-title">machwan</span><br/>
                                               <span className="cart-title">South West Delhi</span><br/>
                                               <span className="cart-title">DELHI</span><br/>
                                               <span className="cart-title">110022</span><br/>
                                               <span className="cart-title">09899677985</span><br/>
                                           </td>
                                            <td className="cart-border">
                                               <span className="cart-title"><b>Order Date</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Delivery Preference</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Buyer Name</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Payment Mode</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Tracking Number</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Tracking Url</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Courier Name</b> : {}	</span><br/>
                                           </td>
                                           <td className="cart-border">
                                            <div style={{verticalAlign:"top"}}>
                                               <span className="cart-title"><b>Total</b> : {}	</span><br/>
                                               <span className="cart-title"><b>Shipping Charge</b> : {}	</span><br/>
                                               <span className="cart-title"><b>ECash </b> : {}	</span><br/>
                                               <span className="cart-title"><b>Grand Total</b> : {}	</span><br/>
                                               <span className="cart-title"> 	</span><br/>

                                               </div>
                                           </td>
                                       </tr>
                                   </tbody>
                               </table>
                               <span className="cart-title" style={{float:"left"}} ><a className="btn btn-secondary" onClick={() => handleBackPreviewOrder()} >Back</a></span>
                                <span className="cart-title" style={{float:"right"}} ><a className="theme-btn " onClick={() => handlePreviewOrder()} >Confirm Cancellation</a></span>
                           </div>
                           
                       </div>
                       
                   </div>
               </div> */}

           </div>
       </div>
   



   
       </>);
}

export default OrderStatus;